import { render } from "./DateRangePickerBtn.vue?vue&type=template&id=c118a074&ts=true"
import script from "./DateRangePickerBtn.vue?vue&type=script&lang=ts"
export * from "./DateRangePickerBtn.vue?vue&type=script&lang=ts"

import "./DateRangePickerBtn.vue?vue&type=style&index=0&id=c118a074&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
